<template lang="html">
    <!-- Datatable component with multiple stuff -->
    <div class="datatable">

        <!-- the toolbar, when click on selected item on lists -->
        <!-- #region - Toolbar -->
        <transition name="fade" v-if="toolbar">
            <v-toolbar fixed flat color="primary" transition="slide-y-transition" v-if="selectable && selected.length">
                <v-btn icon @click="selected = []"><v-icon dark>remove_circle</v-icon></v-btn>
                <div>{{selected.length}} {{selected.length | pluralize('sélectionné') }} </div>
                <v-spacer></v-spacer>
                <!-- tools are given as props when components is called -->
                <template v-for="tool in toolbar">
                    <template v-if="(tool.level && tool.level <= $store.state.auth.user.level) || !tool.level">
                        <template v-if="tool.text">
                            <v-btn round light depressed small @click="tool.callback">{{tool.text}}</v-btn>
                        </template>
                        <template v-else>
                            <template v-if="tool.dropdown">
                                <v-menu offset-y class="select_action">
                                    <v-btn slot="activator" flat>
                                        <v-icon dark>{{tool.icon}}</v-icon>
                                    </v-btn>
                                    <v-list v-for="(dropdown, index) in tool.dropdown" :key="index">
                                        <v-list-tile @click="dropdown.callback" class="li">{{ dropdown.text }}</v-list-tile>
                                    </v-list>
                                </v-menu>
                            </template>
                            <template v-else>
                                <v-btn flat class="select_action" @click="tool.callback"><v-icon dark>{{tool.icon}}</v-icon></v-btn>
                            </template>
                        </template>
                    </template>
                </template>
            </v-toolbar>
        </transition>
        <!-- #endregion -->

        <!-- the breadcrumbs -->
        <!-- #region - Breadcrumbs -->
        <v-breadcrumbs v-if="views" id="breadcrumbs">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item>
                <!-- thanks to teh route name, construct the breadcrumbs -->
                <router-link :to="{ name: views[0].link }">{{ type }}{{ customRouteName }}</router-link>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item>
                {{ name }}
            </v-breadcrumbs-item>
       </v-breadcrumbs>
        <!-- #endregion -->

        <!-- multiples views & actions on lists -->
        <!-- #region - Actions -->
        <div class="action_bar"
            v-scroll="{target: '#scroll-target', callback: this.onScroll}"
            :class="{'fixed': scrollPosition > 90 && isFixed}"
            v-if="views || actions"
        >
            <!-- first all views given as props -->
            <div class="views" v-if="views">
                <v-menu offset-y>
                    <div class="view_title" slot="activator">{{ name }} ({{ totalItems }})
                        <v-icon>arrow_drop_down</v-icon>
                    </div>
                    <v-list v-if="views && views.length" class="view-list">
                        <v-list-tile v-for="(view, index) in views" :key="index" class="li">
                            <template>
                                <router-link :to="{ name: view.link }" class="view_menu" @click.native="selected = []">
                                    {{ view.text }}
                                </router-link>
                            </template>
                            <v-divider v-if="index > 0 && index < (view.length - 1)"></v-divider>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </div>
            <v-spacer></v-spacer>
            <!-- then actions given as props too -->
            <div class="actions" v-if="actions">
                <template v-for="action in actions">
                    <template v-if="(action.level && action.level <= $store.state.auth.user.level) || !action.level">
                        <template v-if="action.dropdown">
                            <!-- many styles, depend of the array given, exist dropdown, simple btn with icon & text or just text -->
                            <v-menu offset-y>
                                <v-btn slot="activator" round color="primary" depressed small class="dropdown">
                                    {{ action.text }}
                                    <v-icon right dark>{{action.icon}}</v-icon>
                                </v-btn>
                                <v-list v-for="(dropdown, index) in action.dropdown" :key="index">
                                    <v-list-tile class="li">
                                        <v-list-tile-content @click="dropdown.callback">{{ dropdown.text }}</v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                        </template>
                        <template v-else>
                            <v-btn round outline color="primary" @click="action.callback" small class="normal">
                                <v-icon left color="primary">{{action.icon}}</v-icon>
                                {{ action.text }}
                            </v-btn>
                        </template>
                    </template>
                </template>
            </div>
        </div>
        <!-- #endregion -->

        <!-- the table -->
        <!-- #region - Table -->
        <!-- datatable item from vuetify -->
        <v-data-table
            :headers="headers"
            :items="items"
            :pagination.sync="pagination"
            :total-items="totalItems"
            :loading="loading"
            v-model="selected"
            :rows-per-page-items="per_page"
            :select-all="selectable ? 'accent' : false"
            :hide-actions="totalItems <= per_page[0]"
            :no-data-text="noDataText"
            rows-per-page-text="Eléments par page :"
        >

            <template slot="items" slot-scope="props">
                <tr @click.stop="rowClick(props.item)">
                    <td v-if="selectable" @click.stop class="checkbox">
                        <v-checkbox hide-details v-model="props.selected" color="accent"></v-checkbox>
                    </td>
                    <slot name="items" v-bind="props"></slot>
                </tr>
            </template>

        </v-data-table>
        <!-- #endregion -->

    </div>
</template>

<script>
    import pluralize from '../filters/pluralize.js'

    export default {

        props: {
            headers: {
                type: Array,  required: true
            },
            endpoint: {
                type: Object, required: false
            },
            toolbar: {
                type: Array,  required: false
            },
            actions: {
                type: Array,  required: false
            },
            views: {
                type: Array,  required: false
            },
            selectable: {
                type: Boolean, default: false
            },
            storeId: {
                type: String, required: true
            },
            isFixed: {
                type: Boolean, required: false, default: true
            },
            customRouteName : {
                type: String, required:false, default:''
            }
        },

        data() {
            return {
                items: [],
                selected: [],
                loading: true,
                totalItems: 0,
                pagination: {
                    page: 1,
                    sortBy: 'updated_at',
                    descending: true,
                },
                pagination_watching: false,
                per_page:[10, 20, 50],
                noDataText: 'Chargement des données en cours...',
                scrollPosition: ''
            }
        },

        computed: {
            // get the name of the catual view -- for the breadcrumbs
            name() {
                let title
                this.views.forEach(v => {
                    if(v.link == this.$route.name){
                        title = v.text
                    }
                })
                return title
            },

            type() {
                let type = this.$route.path.split('/')
                return type[1]
            }
        },

        methods: {
            // Create the axios get request from props given
            getDataFromApi() {
                if( this.endpoint ) {

                    this.loading = 'accent'

                    const { sortBy, descending, page, rowsPerPage } = this.pagination

                    let api_url = this.endpoint.base + '?';

                    let cPage = page
                    if(this.$store.state.datatable[this.storeId] && this.$store.state.datatable[this.storeId].page) {
                        cPage                   = this.$store.state.datatable[this.storeId].page
                        this.pagination.page    = cPage
                    }

                    if(rowsPerPage > -1) {
                        api_url += '&page=' + cPage + '&per_page=' + rowsPerPage;
                    }

                    if(this.endpoint.filters) {
                        api_url += '&filters=' + this.endpoint.filters;
                    }

                    if(this.endpoint.metas) {
                        api_url += '&metas=' + this.endpoint.metas;
                    }

                    if(this.endpoint.embed) {
                        api_url += '&embed=' + this.endpoint.embed;
                    }


                    let cSortBy     = sortBy
                    let cDescending = descending
                    if(this.$store.state.datatable[this.storeId] && this.$store.state.datatable[this.storeId].sortBy) {
                        cSortBy                     = this.$store.state.datatable[this.storeId].sortBy
                        this.pagination.sortBy      = cSortBy

                        cDescending                 = this.$store.state.datatable[this.storeId].descending
                        this.pagination.descending  = cDescending
                    }

                    if(this.endpoint.order){
                        cSortBy                     = this.endpoint.order
                        cDescending                 = this.endpoint.cDescending
                    }

                    if(cSortBy != null) {
                        api_url += '&order=' + cSortBy + '|';
                        api_url += cDescending ? 'DESC' : 'ASC';
                    }
                    this.axios.get(api_url)
                        .then(response => {
                            this.totalItems = response.data.count
                            if(this.endpoint.dataRoot) {
                                this.items = response.data.data[this.endpoint.dataRoot]
                            } else {
                                this.items = response.data.data
                            }
                            this.loading                = false
                            this.pagination_watching    = true

                            if(this.totalItems == 0) {
                                this.noDataText = 'Aucune donnée...'
                            }

                            this.$emit('total_updated', this.totalItems)
                            this.$eventHub.$emit('getItems', this.items)
                        })
                        .catch(error => {
                            this.loading    = 'warning'
                            this.noDataText = 'Le chargement des données a échoué !'
                        })
                } else {
                    return null
                }
            },

            rowClick(item) {
                // when click on row
                this.$emit('rowClick', item);
            },

            setPagination(page = 1, sortBy = 'updated_at', descending = true) {
                this.pagination.page            = page

                if(sortBy != 'updated_at') {
                    this.pagination.sortBy      = sortBy
                }

                if(descending != true) {
                    this.pagination.descending  = descending
                }

                this.$store.dispatch('setPagination', { tableId: this.storeId, page, sortBy, descending })
            },

            onScroll(e) {
                this.scrollPosition = e.target.scrollTop
            },

            reload(){
                this.getDataFromApi()
                this.selected = []
            }

        },

        watch: {
            pagination: function() {
                if(this.pagination_watching) {
                    this.setPagination(this.pagination.page, this.pagination.sortBy, this.pagination.descending)
                    this.getDataFromApi()
                }
            },

            selected: function(val) {
                this.$store.dispatch('setSelected', { tableId: this.storeId, selected: val })
            },
        },

        created() {
            this.$store.dispatch('clearSelected', { tableId: this.storeId })
        },

        mounted() {
            this.getDataFromApi()
        }

    }
</script>

<style lang="stylus" scoped>
    @require '../assets/css/variables'

    div.datatable {
        & >>> thead tr:first-of-type{
            border-bottom: 1px solid $border-light-color
        }
        & >>> th {
            text-transform: uppercase
            color: $text-color
            font-weight: 500
        }
        & >>> tr {
            cursor: pointer
            &:hover {
                background: #F9FBFD!important
            }
            td {
                height: 60px
                a {
                    color: $text-color
                    text-decoration: none
                }
            }
        }
        & >>> nav.toolbar {
            left: auto
            right: 0
            z-index: 5

            div.toolbar__content {
                height: $app-header-height !important
                color: #FFF
                font-weight: 600
                i.icon {
                    font-size: 1.8rem
                }
                .menu, .menu__activator{
                    height: 100%
                }
                .btn {
                    text-transform: none
                    color: $primary-color
                    font-weight: 700
                    padding: 0 0.5rem
                }
                button {
                    &.select_action {
                        margin: 0 auto
                        height: 100%
                        border-right: 1px solid #FFF
                        min-width: 6rem
                        border-left: 1px solid #FFF
                        margin-left:1rem
                        &:nth-of-type(3){
                            border-left: none
                            margin-left:0
                        }
                        .btn {
                            min-width: 6rem
                            margin: 0 auto
                            height: 100%
                        }
                    }
                }
            }
        }
    }

    div.action_bar {
        display: flex
        justify-content: space-between
        align-items: center
        flex-direction: row
        padding: 0 1rem 1rem 1rem

        div.views {
            display: flex
            align-items: center
            .view_title {
                letter-spacing: -1px
                font-weight: 700
                font-size: 3rem
                padding-left: 2rem
                color: $text-color
                text-transform: lowercase
                &:first-letter{
                  text-transform: capitalize
                }
                i {
                    color: $text-color
                }
            }
        }
        div.actions {
            .btn {
                padding: 3px 12px 3px 12px
                height: auto
                & >>> .btn__content {
                    text-transform: none
                    font-weight: 700
                    padding: 0
                    i {
                        margin: 0
                    }
                }
                &.dropdown {
                    i {
                        margin-left: 1rem
                    }
                }
                &.normal {
                    i {
                        margin-right: 1rem
                    }
                }
            }
        }

        &.fixed {
            position: fixed
            top: 0
            background-color: $app-content-background
            z-index: 4
        }
    }

    .view-list {
        .li {
            min-height: 5rem
            display: flex
            align-items: center
            & >>> .list__tile {
                width: 100%
                padding: 0
                min-height: 5rem
                a.view_menu {
                    color: $primary-color
                    text-decoration: none
                    padding-left: 3rem
                    width: 100%
                    height: 100%
                    display: flex
                    align-items: center
                    color:$text-color
                    text-transform: capitalize
                    &.router-link-exact-active {
                        font-weight: 700
                        background-color: $app-content-background
                    }
                    span {
                        margin-right: 2rem
                    }
                }

            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DataTable.vue